import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown, Badge } from "react-bootstrap";
import { FaShoppingCart, FaUser } from "react-icons/fa";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/usersApiSlice";
import { logout } from "../slices/authSlice";
import SearchBox from "./SearchBox";
// import logo from "../assets/logo.png";
import logo from "../assets/hoshvim-plus-logo.webp";
import { resetCart } from "../slices/cartSlice";
import { useGetDiscountQuery } from "../slices/discountApiSlice";

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const { data: discount } = useGetDiscountQuery();
  const bannerActive =
    discount?.isActive &&
    discount?.endTime &&
    new Date() <= new Date(discount.endTime);
  const navbarTop = bannerActive ? '40px' : '0px';

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate("/login");
    } catch (err) {
      console.error(err);
    }
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header>
      {/* Change bg="primary" to get brads look */}
      <Navbar
        expand="lg"
        collapseOnSelect
        fixed="top"
        style={{ backgroundColor: "#fff", padding: "0px", top: navbarTop }}
        className={scrolled ? "navbar-shadow" : ""}
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img
                src={logo}
                alt="Logo"
                height="80" // Adjust the height as needed
                className="d-inline-block align-top"
              />
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <SearchBox />
              <LinkContainer to="/cart" style={{ textAlign: "right", paddingRight: "1.3rem" }}>
                <Nav.Link>
                  עגלה <FaShoppingCart />
                  {cartItems.length > 0 && (
                    <Badge pill bg="success" style={{ marginLeft: "5px" }}>
                      {cartItems.reduce((a, c) => a + c.qty, 0)}
                    </Badge>
                  )}
                </Nav.Link>
              </LinkContainer>
              {userInfo ? (
                <>
                  <NavDropdown title={userInfo.name} id="username" style={{ textAlign: "right", paddingRight: "1.3rem" }}>
                    <LinkContainer to="/profile" style={{ textAlign: "right" }}>
                      <NavDropdown.Item>פרופיל</NavDropdown.Item>
                    </LinkContainer>
                    <NavDropdown.Item
                      onClick={logoutHandler}
                      style={{ textAlign: "right" }}
                    >
                      יציאה
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <LinkContainer to="/login" style={{ textAlign: "right", paddingRight: "1.3rem" }}>
                  <Nav.Link>
                    כניסה <FaUser />
                  </Nav.Link>
                </LinkContainer>
              )}
              {userInfo && userInfo.isAdmin && (
                <NavDropdown title="Admin" id="adminmenu" style={{ textAlign: "right", paddingRight: "1.3rem" }}>
                  <LinkContainer
                    to="/admin/productlist"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>מוצרים</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to="/admin/orderlist"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>הזמנות</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to="/admin/userlist"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>לקוחות</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to="/admin/contactus"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>פניות</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to="/admin/categorylist"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>קטגוריות</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to="/admin/discount"
                    style={{ textAlign: "right" }}
                  >
                    <NavDropdown.Item>מנהל</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
export default Header;
